module.exports = __webpack_public_path__ + "src/assets/textures/env/tractor/tractor_front_wheels_2k_bake.png";